/**
 * Última visita do usuário a cada funil, para o badge de "oportunidades novas" do
 * dropdown de funis (navbar). Fica no navegador, por usuário: é conveniência de
 * leitura, e perder o registro só zera o badge.
 *
 * O backend conta o que ENTROU em cada funil depois dessa data
 * (`POST sales/deals/new-counts`).
 */

const STORAGE_PREFIX = 'sales:pipeline-last-seen:'
export const PIPELINE_SEEN_EVENT = 'sales:pipelines:seen'

type LastSeenMap = Record<number, string>

const storageKey = (userId: number) => `${STORAGE_PREFIX}${userId}`

export function readPipelineLastSeen(userId: number): LastSeenMap {
    try {
        const raw = localStorage.getItem(storageKey(userId))
        return raw ? (JSON.parse(raw) as LastSeenMap) : {}
    } catch {
        return {}
    }
}

function write(userId: number, map: LastSeenMap) {
    try {
        localStorage.setItem(storageKey(userId), JSON.stringify(map))
    } catch {
        // Armazenamento bloqueado (aba anônima, cota): o badge só deixa de lembrar.
    }
}

/**
 * Garante uma data para todo funil listado. Funil que nunca foi visto começa
 * "agora": sem isso o primeiro acesso mostraria todo o histórico como novo.
 */
export function ensurePipelineLastSeen(userId: number, pipelineIds: number[]): LastSeenMap {
    const map = readPipelineLastSeen(userId)
    const now = new Date().toISOString()
    let changed = false
    for (const id of pipelineIds) {
        if (!map[id]) {
            map[id] = now
            changed = true
        }
    }
    if (changed) write(userId, map)
    return map
}

/** Entrar no funil zera a contagem dele. */
export function markPipelineSeen(userId: number, pipelineId: number) {
    const map = readPipelineLastSeen(userId)
    map[pipelineId] = new Date().toISOString()
    write(userId, map)
    window.dispatchEvent(new CustomEvent(PIPELINE_SEEN_EVENT, { detail: { pipelineId } }))
}
